import { render, staticRenderFns } from "./PpDescSelect.vue?vue&type=template&id=3a90ab34&scoped=true&"
import script from "./PpDescSelect.vue?vue&type=script&lang=js&"
export * from "./PpDescSelect.vue?vue&type=script&lang=js&"
import style0 from "./PpDescSelect.vue?vue&type=style&index=0&id=3a90ab34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a90ab34",
  null
  
)

export default component.exports